<template>
  <div :class="[`container-${photoType}`, 'photo-with-frame-container']">
    <img v-if="isBackFrame" :src="backFrameImage" class="back-frame" />
    <div :style="wrapperStyle">
      <div
        :class="['photo-with-frame', `container-${photoType}`]"
        :style="borderStyle"
      >
        <!-- メイン画像はここで定義 -->
        <img
          v-if="is2ShotWidthFixed"
          :src="imageUrl"
          :class="['photo-img', `photo-2shot-width-fixed`]"
        />
        <img
          v-else
          :src="imageUrl"
          :class="['photo-img', `photo-${photoType}`]"
        />
        <!--  特殊ケースとして、背景フレームの処理 -->
        <template v-if="isBackFrame">
          <BandFrameWithBackFrame
            v-if="isShowBandTextIfExistFrame"
            :cast-name="castName"
            :group-name="groupName"
            :open-date="openDate"
            :part="part"
            :type="photoType"
            :copyright="copyright"
            :logo-image="logoImage"
            :campaign-text="campaignText"
          />
        </template>
        <!-- フレーム周りがここより下 -->
        <template v-else>
          <div
            v-if="
              is1ShotAKB48 ||
                is1ShotAKB48_62nd ||
                is1ShotAKB48_63rd ||
                is1ShotAKB48_64th ||
                is1ShotAKB48_10th_AL ||
                is1ShotAKB48_65th
            "
            class="one-shot-akb-frame"
          >
            <div class="one-shot-akb-frame-left">
              <img :src="logoImage" class="one-shot-akb-frame-left-logo" />
              <div
                class="one-shot-akb-frame-left-event"
                :style="akbEventNameStyle"
              >
                {{ date }} {{ campaignText }}
              </div>
            </div>
            <div class="one-shot-akb-frame-right">
              <div class="one-shot-akb-frame-right-cast-group">
                {{ groupName }}
              </div>
              <div
                class="one-shot-akb-frame-right-cast-name"
                :style="nameTextStyle"
              >
                {{ castName }}
              </div>
              <div class="one-shot-akb-frame-right-copyright">
                {{ copyright }}
              </div>
            </div>
          </div>
          <div v-else-if="is1Shot && frameImage" class="one-shot-frame-image">
            <img
              class="one-shot-frame-image-img"
              :src="frameImage"
              alt="frame"
            />
          </div>
          <div v-else-if="is1Shot" class="one-shot-frame">
            <div class="one-shot-frame-left">
              <img :src="logoImage" class="one-shot-frame-left-img" />
              <div class="one-shot-frame-left-event">
                {{ date }} {{ campaignText }}
              </div>
            </div>
            <div class="one-shot-frame-right">
              <div class="one-shot-frame-right-cast">
                <div class="one-shot-frame-right-cast-group">
                  {{ groupName }}
                </div>
                <div
                  class="one-shot-frame-right-cast-name"
                  :style="nameTextStyle"
                >
                  {{ castName }}
                </div>
              </div>
              <div class="one-shot-frame-right-copyright">
                {{ copyright }}
              </div>
            </div>
          </div>
          <div
            v-else-if="is2ShotWidthFixed"
            class="two-shot-width-fixed-frame-image"
          >
            <img
              class="two-shot-width-fixed-frame-image-img"
              :src="frameImage"
              alt="frame"
            />
          </div>
          <div v-else-if="is2ShotWide" class="two-shot-wide-frame-image">
            <img
              class="two-shot-wide-frame-image-img"
              :src="frameImage"
              alt="frame"
            />
          </div>
          <div v-else-if="!is1Shot && frameImage" class="two-shot-frame-image">
            <img
              class="two-shot-frame-image-img"
              :src="frameImage"
              alt="frame"
            />
          </div>
          <div v-else class="two-shot-frame">
            <div class="two-shot-frame-left">
              <div>
                {{ date }}
              </div>
              <div>{{ campaignText }}</div>
            </div>
            <img :src="logoImage" class="two-shot-frame-center" />
            <div class="two-shot-frame-right">
              <div class="two-shot-frame-right-cast">
                <div class="two-shot-frame-right-cast-group">
                  {{ groupName }}
                </div>
                <div
                  class="two-shot-frame-right-cast-name"
                  :style="nameTextStyle"
                >
                  {{ castName }}
                </div>
              </div>
              <div class="two-shot-frame-right-copyright">
                {{ copyright }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '~/helpers/date'
import { GarallyPhotoType } from '~/helpers/garally'
import BandFrameWithBackFrame from '~/components/organisms/BandFrameWithBackFrame'

export default {
  components: {
    BandFrameWithBackFrame
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    castName: {
      type: String,
      required: true
    },
    groupName: {
      type: String,
      required: true
    },
    openDate: {
      type: String,
      required: true
    },
    part: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    copyright: {
      type: String,
      default: ''
    },
    logoImage: {
      type: String,
      default: ''
    },
    campaignText: {
      type: String,
      default: ''
    },
    frameImage: {
      type: String,
      default: undefined
    },
    backFrameImage: {
      type: String,
      default: undefined
    },
    isBackFrame: {
      type: Boolean,
      default: false
    },
    isShowBandTextIfExistFrame: {
      type: Boolean,
      default: false
    },
    frameTextColor: {
      type: String,
      default: undefined
    },
    frameBackgroundColor: {
      type: String,
      default: undefined
    },
    castNameLetterSpacing: {
      type: String,
      default: undefined
    },
    castNameMarginRight: {
      type: String,
      default: undefined
    }
  },
  computed: {
    wrapperStyle() {
      if (!this.isBackFrame) {
        return undefined
      }
      return {
        position: 'absolute',
        zIndex: '1',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        transform: this.is1Shot ? 'scale(0.865)' : 'scale(0.884)',
        paddingTop: this.is1Shot ? '16px' : '24px'
      }
    },
    // borderじゃなくなっちゃったけど、いい名前が思いつかないので一旦このまま
    borderStyle() {
      if (this.isBackFrame) {
        return undefined
      }
      return {
        border: '2px solid #333333',
        color: this.frameTextColor ? `#${this.frameTextColor}` : undefined,
        backgroundColor: this.frameBackgroundColor
          ? `#${this.frameBackgroundColor}`
          : undefined
      }
    },
    photoType() {
      // twoShotWidthFixedだけは、db上は存在せず、FEで判別している
      if (
        (this.type === GarallyPhotoType.twoShotWide ||
          this.type === GarallyPhotoType.twoShot) &&
        this.frameImage
      ) {
        return GarallyPhotoType.twoShotWidthFixed
      }
      return this.type
    },
    is1Shot() {
      return this.photoType === GarallyPhotoType.oneShot
    },
    is1ShotAKB48() {
      return this.photoType === GarallyPhotoType.oneShotAKB48
    },
    is1ShotAKB48_62nd() {
      return this.photoType === GarallyPhotoType.oneShotAKB48_62nd
    },
    is1ShotAKB48_63rd() {
      return this.photoType === GarallyPhotoType.oneShotAKB48_63rd
    },
    is1ShotAKB48_64th() {
      return this.photoType === GarallyPhotoType.oneShotAKB48_64th
    },
    is1ShotAKB48_10th_AL() {
      return this.photoType === GarallyPhotoType.oneShotAKB48_10th_AL
    },
    is1ShotAKB48_65th() {
      return this.photoType === GarallyPhotoType.oneShotAKB48_65th
    },
    is2ShotWide() {
      return this.photoType === GarallyPhotoType.twoShotWide
    },
    // デバイスによって、写真のサイズが異なってしまうため、画像幅のみを固定するタイプ
    is2ShotWidthFixed() {
      return this.photoType === GarallyPhotoType.twoShotWidthFixed
    },
    akbEventNameStyle() {
      let letterSpacing
      if (this.is1ShotAKB48_10th_AL) {
        letterSpacing = '3.6px'
      } else if (this.is1ShotAKB48_65th) {
        letterSpacing = '2.5px'
      }
      return {
        letterSpacing
      }
    },
    date() {
      return formatDate(this.openDate, 'D.MMM.YYYY')
    },
    nameTextStyle() {
      if (this.castNameLetterSpacing && this.castNameMarginRight) {
        return {
          letterSpacing: `${this.castNameLetterSpacing}px`,
          marginRight: `${this.castNameMarginRight}px`
        }
      }
      const nameLength = this.castName.length
      if (this.is1Shot) {
        if (nameLength === 4) {
          return {
            letterSpacing: '23px',
            marginRight: '-27px'
          }
        }

        if (nameLength === 5) {
          return {
            letterSpacing: '6px',
            marginRight: '-10px'
          }
        }

        if (nameLength === 6) {
          return {
            letterSpacing: '-1px',
            marginRight: '-10px'
          }
        }
      }

      if (this.is1ShotAKB48_10th_AL) {
        if (nameLength === 3) {
          return {
            letterSpacing: '25px',
            marginRight: '-26px'
          }
        }

        if (nameLength === 4) {
          return {
            letterSpacing: '14px',
            marginRight: '-16px'
          }
        }

        if (nameLength === 5) {
          return {
            letterSpacing: '5px',
            marginRight: '-8px'
          }
        }
      }

      if (this.is1ShotAKB48_65th) {
        if (nameLength === 3) {
          return {
            letterSpacing: '50px',
            marginRight: '-49px'
          }
        }

        if (nameLength === 4) {
          return {
            letterSpacing: '26px',
            marginRight: '-27px'
          }
        }

        if (nameLength === 5) {
          return {
            letterSpacing: '9px',
            marginRight: '-11px'
          }
        }
      }

      if (nameLength === 4) {
        return {
          letterSpacing: '25px',
          marginRight: '-28px'
        }
      }

      if (nameLength === 5) {
        return {
          letterSpacing: '11px',
          marginRight: '-18px'
        }
      }

      return {
        letterSpacing: '1px',
        marginRight: '-10px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$frame-height: 130px;

.photo-with-frame-container {
  position: relative;
}
.back-frame {
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.photo-with-frame {
  * {
    font-family: 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro',
      'Hiragino Maru Gothic Pro', 'ヒラギノ角ゴ Pro W3',
      'Hiragino Kaku Gothic Pro', 'HG丸ｺﾞｼｯｸM-PRO', 'HGMaruGothicMPRO' !important;
  }
}
.container-1shot {
  width: 750px;
  height: calc(1000px + #{$frame-height});
}
.container-1shot-AKB48 {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #f6f5f1;
}
.container-1shot-AKB48-62nd {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #afa3ce;
  color: white;
}
.container-1shot-AKB48-63rd {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #ca95ad;
  color: white;
}
.container-1shot-AKB48-64th {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #fff;
  color: #000;
}
.container-1shot-AKB48-10th-AL {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #b5b5b6;
  color: #fff;
}
.container-1shot-AKB48-65th {
  width: 750px;
  height: calc(1000px + #{$frame-height});
  background-color: #fff;
  color: #000;
}
.container-2shot {
  width: 1000px;
  height: calc(750px + #{$frame-height});
}
.container-2shot-wide {
  width: 1000px;
  height: 570px;
}
.container-2shot-width-fixed {
  width: 1000px;
}
.photo-img {
  display: block;
  object-fit: cover;
  pointer-events: none;
}
.photo-1shot {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48 {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48-62nd {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48-63rd {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48-64th {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48-10th-AL {
  width: 746px;
  height: 1000px;
}
.photo-1shot-AKB48-65th {
  width: 746px;
  height: 1000px;
}
.photo-2shot {
  width: 996px;
  height: 750px;
}
.photo-2shot-wide {
  width: 996px;
  height: 463px;
}
.photo-2shot-width-fixed {
  width: 996px;
  height: auto;
}

.one-shot-frame {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  width: 750px;
  height: $frame-height;

  &-left {
    margin-top: -12px;
    &-img {
      margin-left: -15px;
      height: 80px;
      display: block;
      pointer-events: none;
    }

    &-event {
      font-size: 15px;
    }
  }

  &-right {
    &-cast {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &-group {
        font-size: 21px;
        line-height: 46px;
        margin-right: 12px;
      }

      &-name {
        font-size: 44px;
        line-height: 46px;
      }
    }

    &-copyright {
      font-size: 16px;
      text-align: right;
    }
  }
}

.one-shot-akb-frame {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  width: 750px;
  height: $frame-height;

  &-left {
    &-logo {
      height: 74px;
      display: block;
      pointer-events: none;
      margin-bottom: 8px;
    }

    &-event {
      font-size: 16px;
    }
  }

  &-right {
    &-cast {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &-group {
        font-size: 21px;
        line-height: 26px;
        margin-right: 12px;
        font-weight: bold;
      }

      &-name {
        font-size: 44px;
        line-height: 46px;
        font-weight: bold;
      }
    }

    &-copyright {
      font-size: 16px;
      text-align: right;
    }
  }
}

.two-shot-frame {
  height: $frame-height;
  width: 1000px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;

  &-left {
    font-size: 17px;
    line-height: 1.5;
  }

  &-center {
    display: block;
    height: 100px;
    pointer-events: none;
  }

  &-right {
    &-cast {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      &-group {
        font-size: 20px;
        margin-right: 12px;
        line-height: 24px;
      }

      &-name {
        font-size: 38px;
        line-height: 40px;
      }
    }

    &-copyright {
      font-size: 15px;
      text-align: right;
    }
  }
}

.two-shot-width-fixed-frame-image {
  width: 1000px;
  &-img {
    width: calc(1000px - 4px);
    object-fit: cover;
    display: block;
  }
}

.one-shot-frame-image {
  height: $frame-height;
  width: 750px;

  &-img {
    width: calc(750px - 4px);
    height: calc(#{$frame-height} - 2px);
    object-fit: cover;
    display: block;
  }
}

.two-shot-frame-image {
  height: $frame-height;
  width: 1000px;

  &-img {
    width: calc(1000px - 4px);
    height: calc(#{$frame-height} - 2px);
    object-fit: cover;
    display: block;
  }
}

.two-shot-wide-frame-image {
  height: 105px;
  width: 1000px;

  &-img {
    width: calc(1000px - 4px);
    height: calc(105px - 2px);
    object-fit: cover;
    display: block;
  }
}
</style>
